import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutGrid, FileStack, Users, Settings, LogOut, Menu, FileSignature, CalendarClock, FolderOpen, MailSearch } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Panoramica", icon: LayoutGrid, id: "dashboard", end: true },
  { to: "/dipendenti", label: "Dipendenti", icon: Users, id: "dipendenti" },
  { to: "/contratti", label: "Contratti", icon: FileSignature, id: "contratti" },
  { to: "/scadenze", label: "Scadenze", icon: CalendarClock, id: "scadenze" },
  { to: "/documenti", label: "Documenti", icon: FolderOpen, id: "documenti" },
  { to: "/cedolini", label: "Cedolini", icon: FileStack, id: "cedolini" },
  { to: "/importazioni", label: "Importazioni email", icon: MailSearch, id: "importazioni" },
  { to: "/impostazioni", label: "Impostazioni", icon: Settings, id: "impostazioni" },
];

const ROLE_LABEL = { admin: "Amministratore", operator: "Operatore" };

const SidebarContent = ({ onNavigate, prefix }) => {
  const { user, logout } = useAuth();
  return (
    <div className="flex h-full flex-col bg-[#1f3a27] text-slate-300">
      <div className="flex items-center gap-3 px-6 py-7">
        <img src="/organico-logo.svg" alt="Organico" className="h-9 w-9 rounded-md" data-testid="app-logo" />
        <div>
          <p className="font-display text-base font-bold text-white leading-tight">Organico</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Gestione personale</p>
        </div>
      </div>
      <nav className="flex-1 space-y-1 px-3">
        {NAV.map(({ to, label, icon: Icon, id, end }) => (
          <NavLink key={to} to={to} end={end} onClick={onNavigate} data-testid={`${prefix}nav-${id}-link`}
            className={({ isActive }) =>
              `group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors duration-150 ${isActive ? "bg-white/10 text-white" : "hover:bg-white/5 hover:text-white"}`}>
            <Icon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-white/10 p-4">
        <p className="truncate px-2 text-xs text-slate-400" data-testid={`${prefix}current-user-email`}>{user?.email}</p>
        <p className="px-2 text-[11px] uppercase tracking-wider text-[#b7d8bd]" data-testid={`${prefix}current-user-role`}>{ROLE_LABEL[user?.role] || user?.role}</p>
        <button data-testid={`${prefix}logout-button`} onClick={logout}
          className="mt-2 flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm text-slate-300 transition-colors hover:bg-white/5 hover:text-white">
          <LogOut className="h-4 w-4" /> Esci
        </button>
      </div>
    </div>
  );
};

export default function AppLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#f3f7f3]">
      <aside className="fixed inset-y-0 left-0 hidden w-64 lg:block"><SidebarContent prefix="" /></aside>
      <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b border-slate-200 bg-white/80 px-4 backdrop-blur-md lg:hidden">
        <p className="font-display font-bold text-slate-900 flex items-center gap-2"><img src="/organico-logo.svg" alt="" className="h-6 w-6 rounded" /> Organico</p>
        <button data-testid="mobile-menu-button" onClick={() => setOpen(true)} className="rounded-md p-2 hover:bg-slate-100" aria-label="Menu"><Menu className="h-5 w-5" /></button>
      </header>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-64 border-0 p-0">
          <SheetTitle className="sr-only">Menu</SheetTitle>
          <SidebarContent prefix="mobile-" onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
      <main className="lg:pl-64"><div className="mx-auto max-w-7xl space-y-8 p-4 sm:p-6 lg:p-10"><Outlet /></div></main>
    </div>
  );
}
